<app-header-style-one></app-header-style-one>
<!-- <div *ngFor="let x of jobsScrollData" class="marquee">
    <marquee behavior="" direction="">{{x.message}}.</marquee>
</div> -->
<!-- <div class="marquee">
    <marquee behavior="scroll" direction="left" scrollamount="6">
         <strong>Job Updates:</strong>
        <span *ngFor="let x of jobsScrollData; let last = last">{{ x.message }} <span *ngIf="!last"> | </span>
        </span>
    </marquee>
</div> -->

<div class="marquee" style="display: flex;">
    <div class="container" style="display: flex;">
        <strong style="white-space: nowrap; margin-right: 10px;color: #fff;">Job Updates:</strong>
        <marquee behavior="scroll" direction="left" scrollamount="6" style="flex: 1;" onmouseover="this.stop();"
            onmouseout="this.start();">
            <span *ngFor="let x of melanotifcations; let last = last">
                <img src="assets/img/mepma/mic.svg" alt="" style="width: 24px;height: 24px;"> {{ x.mela_name }} <span
                    class="blinking" (click)="gotoviewDetails(x)"> *Apply Now* </span><span *ngIf="!last"> | </span>
            </span>
        </marquee>
    </div>
</div>
<!-- <app-homeone-main-banner></app-homeone-main-banner> -->
<!-- <app-about-page-one></app-about-page-one> -->
<!-- item-bg1 -->
<div class="page-title-area item-bg1">
    <!-- <img src="assets/img/mepma/banner.png" alt=""> -->
    <!-- <div class="container">
        <div class="page-title-content">
            <ul>
                <li>&nbsp;</li>
            </ul>
            <h2>&nbsp;</h2>
        </div>
    </div> -->
</div>


<!-- <app-homeone-about></app-homeone-about> -->
<!-- bg-image -->
<div class="courses-categories-area  pt-30 pb-70" style="padding-top: 30px;">
    <div class="container">
        <div class="section-title text-start">

            <h2>MEPMA-NIPUNA JOB MELA</h2>
            <span class="sub-title">&nbsp;</span>
            <a class="default-btn">
                <span>Entry Fees:
                    <span class="fee">₹100/-Only</span> </span>
            </a>
        </div>

        <app-notifications></app-notifications>
        <!-- <app-categories-style-one></app-categories-style-one> -->

        <section><br>
            <div class="row">
                <!-- <div class="col-12" style="text-align: center;">
                    <button class="reg-btn" (click)="navigteApplyForm(melanotifcations[0])"> Click Here For Job Mela
                        Registration
                    </button><br>
                </div> -->
                <div class="col-12" style="text-align: center;margin-top: 18px;">
                    <button class="spot-btn"> Spot Registration Available at Mela Also </button>
                </div>
            </div>
        </section>
        <!-- <br>
        <section>
            <app-registrationform></app-registrationform>
        </section> -->
    </div>
</div>


<div *ngIf="showloader" class="overlap">
    <div class="loader"></div>
</div>